{
    "name": "Creality",
    "version": "01.10.00.01",
    "force_update": "0",
    "description": "Creality configurations",
    "machine_model_list": [
        {
            "name": "Creality CR-10 V2",
            "sub_path": "machine/Creality CR-10 V2.json"
        },
        {
            "name": "Creality CR-10 Max",
            "sub_path": "machine/Creality CR-10 Max.json"
        },
        {
            "name": "Creality Ender-3 V2",
            "sub_path": "machine/Creality Ender-3 V2.json"
        },
        {
            "name": "Creality Ender-3 V3",
            "sub_path": "machine/Creality Ender-3 V3.json"
        },
        {
            "name": "Creality Ender-3 V3 Plus",
            "sub_path": "machine/Creality Ender-3 V3 Plus.json"
        },
        {
            "name": "Creality Ender-3 V3 KE",
            "sub_path": "machine/Creality Ender-3 V3 KE.json"
        },
        {
            "name": "Creality Ender-3 S1",
            "sub_path": "machine/Creality Ender-3 S1.json"
        },
        {
            "name": "Creality Ender-3 S1 Pro",
            "sub_path": "machine/Creality Ender-3 S1 Pro.json"
        },
        {
            "name": "Creality Ender-5",
            "sub_path": "machine/Creality Ender-5.json"
        },
        {
            "name": "Creality Ender-5 Plus",
            "sub_path": "machine/Creality Ender-5 Plus.json"
        },
        {
            "name": "Creality Ender-5S",
            "sub_path": "machine/Creality Ender-5S.json"
        },
        {
            "name": "Creality Ender-5 S1",
            "sub_path": "machine/Creality Ender-5 S1.json"
        },
        {
            "name": "Creality Ender-6",
            "sub_path": "machine/Creality Ender-6.json"
        },
        {
            "name": "Creality CR-6 SE",
            "sub_path": "machine/Creality CR-6 SE.json"
        },
        {
            "name": "Creality CR-6 Max",
            "sub_path": "machine/Creality CR-6 Max.json"
        },
        {
            "name": "Creality K1",
            "sub_path": "machine/Creality K1.json"
        },
        {
            "name": "Creality K1 Max",
            "sub_path": "machine/Creality K1 Max.json"
        },
        {
            "name": "Creality K1C",
            "sub_path": "machine/Creality K1C.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "fdm_process_creality_common",
            "sub_path": "process/fdm_process_creality_common.json"
        },
        {
            "name": "fdm_process_common_klipper",
            "sub_path": "process/fdm_process_common_klipper.json"
        },
        {
            "name": "0.10mm HighDetail @Creality CR-6",
            "sub_path": "process/0.10mm HighDetail @Creality CR-6.json"
        },
        {
            "name": "0.12mm Detail @Creality CR-6",
            "sub_path": "process/0.12mm Detail @Creality CR-6.json"
        },
        {
            "name": "0.16mm Opitmal @Creality CR-6",
            "sub_path": "process/0.16mm Opitmal @Creality CR-6.json"
        },
        {
            "name": "0.16mm Optimal @Creality CR-6 0.2",
            "sub_path": "process/0.16mm Optimal @Creality CR-6 0.2.json"
        },
        {
            "name": "0.16mm Optimal @Creality CR-6 0.4",
            "sub_path": "process/0.16mm Optimal @Creality CR-6 0.4.json"
        },
        {
            "name": "0.24mm Draft @Creality CR-6",
            "sub_path": "process/0.24mm Draft @Creality CR-6.json"
        },
        {
            "name": "0.28mm SuperDraft @Creality CR-6",
            "sub_path": "process/0.28mm SuperDraft @Creality CR-6.json"
        },
        {
            "name": "0.12mm Fine @Creality CR10Max",
            "sub_path": "process/0.12mm Fine @Creality CR10Max.json"
        },
        {
            "name": "0.12mm Fine @Creality Ender3V2",
            "sub_path": "process/0.12mm Fine @Creality Ender3V2.json"
        },
        {
            "name": "0.16mm Optimal @Creality CR10V2",
            "sub_path": "process/0.16mm Optimal @Creality CR10V2.json"
        },
        {
            "name": "0.15mm Optimal @Creality CR10Max",
            "sub_path": "process/0.15mm Optimal @Creality CR10Max.json"
        },
        {
            "name": "0.15mm Optimal @Creality Ender3V2",
            "sub_path": "process/0.15mm Optimal @Creality Ender3V2.json"
        },
        {
            "name": "0.16mm Optimal @Creality Ender3S1",
            "sub_path": "process/0.16mm Optimal @Creality Ender3S1.json"
        },
        {
            "name": "0.16mm Optimal @Creality Ender3S1Pro",
            "sub_path": "process/0.16mm Optimal @Creality Ender3S1Pro.json"
        },
        {
            "name": "0.16mm Optimal @Creality Ender5",
            "sub_path": "process/0.16mm Optimal @Creality Ender5.json"
        },
        {
            "name": "0.16mm Optimal @Creality Ender5Plus",
            "sub_path": "process/0.16mm Optimal @Creality Ender5Plus.json"
        },
        {
            "name": "0.16mm Optimal @Creality Ender5S",
            "sub_path": "process/0.16mm Optimal @Creality Ender5S.json"
        },
        {
            "name": "0.16mm Optimal @Creality Ender5S1",
            "sub_path": "process/0.16mm Optimal @Creality Ender5S1.json"
        },
        {
            "name": "0.16mm Optimal @Creality Ender6",
            "sub_path": "process/0.16mm Optimal @Creality Ender6.json"
        },
        {
			"name": "0.16mm Optimal @Creality K1 0.4 nozzle",
			"sub_path": "process/0.16mm Optimal @Creality K1 0.4 nozzle.json"
		},
		{
			"name": "0.16mm Optimal @Creality K1Max 0.4 nozzle",
			"sub_path": "process/0.16mm Optimal @Creality K1Max 0.4 nozzle.json"
		},
        {
            "name": "0.20mm Normal @Creality CR-6",
            "sub_path": "process/0.20mm Normal @Creality CR-6.json"
        },
        {
            "name": "0.20mm Standard @Creality CR10V2",
            "sub_path": "process/0.20mm Standard @Creality CR10V2.json"
        },
        {
            "name": "0.20mm Standard @Creality CR10Max",
            "sub_path": "process/0.20mm Standard @Creality CR10Max.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender3V2",
            "sub_path": "process/0.20mm Standard @Creality Ender3V2.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender3V3",
            "sub_path": "process/0.20mm Standard @Creality Ender3V3.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender3V3Plus",
            "sub_path": "process/0.20mm Standard @Creality Ender3V3Plus.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender3V3KE",
            "sub_path": "process/0.20mm Standard @Creality Ender3V3KE.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender3S1",
            "sub_path": "process/0.20mm Standard @Creality Ender3S1.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender3S1Pro",
            "sub_path": "process/0.20mm Standard @Creality Ender3S1Pro.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender5",
            "sub_path": "process/0.20mm Standard @Creality Ender5.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender5Plus",
            "sub_path": "process/0.20mm Standard @Creality Ender5Plus.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender5S",
            "sub_path": "process/0.20mm Standard @Creality Ender5S.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender5S1",
            "sub_path": "process/0.20mm Standard @Creality Ender5S1.json"
        },
        {
            "name": "0.20mm Standard @Creality Ender6",
            "sub_path": "process/0.20mm Standard @Creality Ender6.json"
        },
        {
			"name": "0.20mm Standard @Creality K1 0.4 nozzle",
			"sub_path": "process/0.20mm Standard @Creality K1 0.4 nozzle.json"
		},
		{
			"name": "0.20mm Standard @Creality K1Max 0.4 nozzle",
			"sub_path": "process/0.20mm Standard @Creality K1Max 0.4 nozzle.json"
		},
        {
            "name": "0.20mm Standard @Creality K1C",
            "sub_path": "process/0.20mm Standard @Creality K1C.json"
        },
        {
            "name": "0.24mm Draft @Creality CR10Max",
            "sub_path": "process/0.24mm Draft @Creality CR10Max.json"
        },
        {
            "name": "0.24mm Draft @Creality K1 0.4 nozzle",
            "sub_path": "process/0.24mm Draft @Creality K1 0.4 nozzle.json"
        },
        {
            "name": "0.24mm Draft @Creality K1Max 0.4 nozzle",
            "sub_path": "process/0.24mm Draft @Creality K1Max 0.4 nozzle.json"
        },
        {
            "name": "0.24mm Draft @Creality Ender3V2",
            "sub_path": "process/0.24mm Draft @Creality Ender3V2.json"
        },
        {
            "name": "0.08mm SuperDetail @Creality CR-6 0.2",
            "sub_path": "process/0.08mm SuperDetail @Creality CR-6 0.2.json"
        },
        {
            "name": "0.30mm Standard @Creality Ender3V3 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Creality Ender3V3 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Creality Ender3V3Plus 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Creality Ender3V3Plus 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Creality K1 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Creality K1 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Creality K1Max 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Creality K1Max 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @Creality K1C 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @Creality K1C 0.6 nozzle.json"
        },
        {
            "name": "0.32mm Chunky @Creality CR-6 0.6",
            "sub_path": "process/0.32mm Chunky @Creality CR-6 0.6.json"
        },
        {
            "name": "0.36mm SuperChunky @Creality CR-6",
            "sub_path": "process/0.36mm SuperChunky @Creality CR-6.json"
        },
        {
            "name": "0.40mm Standard @Creality K1 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Creality K1 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @Creality K1Max 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Creality K1Max 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @Creality K1C 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @Creality K1C 0.8 nozzle.json"
        },
        {
            "name": "0.44mm SuperExtraChunky @Creality CR-6",
            "sub_path": "process/0.44mm SuperExtraChunky @Creality CR-6.json"
        },
        {
            "name": "0.24mm Optimal @Creality CR-6",
            "sub_path": "process/0.24mm Optimal @Creality CR-6.json"
        },
        {
            "name": "0.32mm Normal @Creality CR-6 0.8",
            "sub_path": "process/0.32mm Normal @Creality CR-6 0.8.json"
        },
        {
            "name": "0.40mm Draft @Creality CR-6",
            "sub_path": "process/0.40mm Draft @Creality CR-6.json"
        },
        {
            "name": "0.48mm Chunky @Creality CR-6",
            "sub_path": "process/0.48mm Chunky @Creality CR-6.json"
        },
        {
            "name": "0.48mm Draft @Creality CR-6",
            "sub_path": "process/0.48mm Draft @Creality CR-6.json"
        },
        {
            "name": "0.56mm SuperChunky @Creality CR-6",
            "sub_path": "process/0.56mm SuperChunky @Creality CR-6.json"
        },
        {
            "name": "0.12mm Detail @Creality 0.2 CR-6",
            "sub_path": "process/0.12mm Detail @Creality 0.2 CR-6.json"
        },
        {
            "name": "0.12mm Detail @Creality 0.4 CR-6",
            "sub_path": "process/0.12mm Detail @Creality 0.4 CR-6.json"
        },
        {
            "name": "0.24mm Draft @Creality 0.6 CR-6",
            "sub_path": "process/0.24mm Draft @Creality 0.6 CR-6.json"
        },
        {
            "name": "0.28mm SuperDraft @Creality 0.6 CR-6",
            "sub_path": "process/0.28mm SuperDraft @Creality 0.6 CR-6.json"
        },
        {
            "name": "0.20mm Normal @Creality CR-6 0.6",
            "sub_path": "process/0.20mm Normal @Creality CR-6 0.6.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_asa",
            "sub_path": "filament/fdm_filament_asa.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "fdm_filament_tpu",
            "sub_path": "filament/fdm_filament_tpu.json"
        },
        {
            "name": "Generic ABS @Creality",
            "sub_path": "filament/Generic ABS @Creality.json"
        },
        {
            "name": "Generic ASA @Creality",
            "sub_path": "filament/Generic ASA @Creality.json"
        },
        {
            "name": "Generic PETG @Creality",
            "sub_path": "filament/Generic PETG @Creality.json"
        },
        {
            "name": "Generic PLA @Creality",
            "sub_path": "filament/Generic PLA @Creality.json"
        },
        {
            "name": "Generic TPU @Creality",
            "sub_path": "filament/Generic TPU @Creality.json"
        },
        {
            "name": "Generic PETG @Creality CR-6",
            "sub_path": "filament/Generic PETG @Creality CR-6.json"
        },
        {
            "name": "Generic ABS @Creality CR-6",
            "sub_path": "filament/Generic ABS @Creality CR-6.json"
        },
        {
            "name": "Generic PLA @Creality CR-6",
            "sub_path": "filament/Generic PLA @Creality CR-6.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "fdm_creality_common",
            "sub_path": "machine/fdm_creality_common.json"
        },
        {
            "name": "Creality CR-10 V2 0.4 nozzle",
            "sub_path": "machine/Creality CR-10 V2 0.4 nozzle.json"
        },
        {
            "name": "Creality CR-10 Max 0.4 nozzle",
            "sub_path": "machine/Creality CR-10 Max 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-3 V2 0.4 nozzle",
            "sub_path": "machine/Creality Ender-3 V2 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-3 V3 0.4 nozzle",
            "sub_path": "machine/Creality Ender-3 V3 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-3 V3 0.6 nozzle",
            "sub_path": "machine/Creality Ender-3 V3 0.6 nozzle.json"
        },
        {
            "name": "Creality Ender-3 V3 Plus 0.4 nozzle",
            "sub_path": "machine/Creality Ender-3 V3 Plus 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-3 V3 Plus 0.6 nozzle",
            "sub_path": "machine/Creality Ender-3 V3 Plus 0.6 nozzle.json"
        },
        {
            "name": "Creality Ender-3 V3 KE 0.4 nozzle",
            "sub_path": "machine/Creality Ender-3 V3 KE 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-3 S1 0.4 nozzle",
            "sub_path": "machine/Creality Ender-3 S1 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-3 S1 Pro 0.4 nozzle",
            "sub_path": "machine/Creality Ender-3 S1 Pro 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-5 0.4 nozzle",
            "sub_path": "machine/Creality Ender-5 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-5 Plus 0.4 nozzle",
            "sub_path": "machine/Creality Ender-5 Plus 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-5S 0.4 nozzle",
            "sub_path": "machine/Creality Ender-5S 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-5 S1 0.4 nozzle",
            "sub_path": "machine/Creality Ender-5 S1 0.4 nozzle.json"
        },
        {
            "name": "Creality Ender-6 0.4 nozzle",
            "sub_path": "machine/Creality Ender-6 0.4 nozzle.json"
        },
        {
            "name": "Creality CR-6 SE 0.2 nozzle",
            "sub_path": "machine/Creality CR-6 SE 0.2 nozzle.json"
        },
        {
            "name": "Creality CR-6 SE 0.4 nozzle",
            "sub_path": "machine/Creality CR-6 SE 0.4 nozzle.json"
        },
        {
            "name": "Creality CR-6 SE 0.6 nozzle",
            "sub_path": "machine/Creality CR-6 SE 0.6 nozzle.json"
        },
        {
            "name": "Creality CR-6 SE 0.8 nozzle",
            "sub_path": "machine/Creality CR-6 SE 0.8 nozzle.json"
        },
        {
            "name": "Creality CR-6 Max 0.2 nozzle",
            "sub_path": "machine/Creality CR-6 Max 0.2 nozzle.json"
        },
        {
            "name": "Creality CR-6 Max 0.4 nozzle",
            "sub_path": "machine/Creality CR-6 Max 0.4 nozzle.json"
        },
        {
            "name": "Creality CR-6 Max 0.6 nozzle",
            "sub_path": "machine/Creality CR-6 Max 0.6 nozzle.json"
        },
        {
            "name": "Creality CR-6 Max 0.8 nozzle",
            "sub_path": "machine/Creality CR-6 Max 0.8 nozzle.json"
        },
        {
            "name": "Creality K1 0.4 nozzle",
            "sub_path": "machine/Creality K1 0.4 nozzle.json"
        },
        {
            "name": "Creality K1 0.6 nozzle",
            "sub_path": "machine/Creality K1 0.6 nozzle.json"
        },
        {
            "name": "Creality K1 0.8 nozzle",
            "sub_path": "machine/Creality K1 0.8 nozzle.json"
        },
        {
            "name": "Creality K1 Max 0.4 nozzle",
            "sub_path": "machine/Creality K1 Max 0.4 nozzle.json"
        },
        {
            "name": "Creality K1 Max 0.6 nozzle",
            "sub_path": "machine/Creality K1 Max 0.6 nozzle.json"
        },
        {
            "name": "Creality K1 Max 0.8 nozzle",
            "sub_path": "machine/Creality K1 Max 0.8 nozzle.json"
        },
        {
            "name": "Creality K1C 0.4 nozzle",
            "sub_path": "machine/Creality K1C 0.4 nozzle.json"
        },
        {
            "name": "Creality K1C 0.6 nozzle",
            "sub_path": "machine/Creality K1C 0.6 nozzle.json"
        },
        {
            "name": "Creality K1C 0.8 nozzle",
            "sub_path": "machine/Creality K1C 0.8 nozzle.json"
        }
    ]
}
